export default "__VITE_PUBLIC_ASSET__b247e62c__"